// extracted by mini-css-extract-plugin
export var chip = "_er-0";
export var filterDropdown = "_er-5";
export var filterItem = "_er-6";
export var icon = "_er-1";
export var removeButton = "_er-3";
export var removeIcon = "_er-4";
export var separator = "_er-2";